import React from 'react';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = ({ items, modifier }) => {
    const classes = classNames(styles['Breadcrumbs'], {
        [styles[`Breadcrumbs--${modifier}`]]: !!modifier,
    });
    return (
        <div>
            <ul className={classes}>
                {items.map((item, i) => {
                    return (
                        <BreadCrumbItem
                            {...item}
                            isActive={i + 1 === items.length}
                            key={i}
                        />
                    );
                })}
            </ul>
        </div>
    );
};

const BreadCrumbItem = ({ text, href, isActive }) => {
    return (
        <li
            className={styles['Breadcrumbs__Item']}
            aria-current={isActive ? 'page' : ''}
        >
            <a href={href} role="button">
                {text}
            </a>
        </li>
    );
};

Breadcrumbs.propTypes = {
    items: PropTypes.array,
};

Breadcrumbs.defaultProps = {
    items: [],
};

BreadCrumbItem.propTypes = {
    text: PropTypes.string,
    isActive: PropTypes.bool,
    href: PropTypes.string,
};

BreadCrumbItem.defaultProps = {
    text: '',
    href: '',
    isActive: false,
};

export default Breadcrumbs;
